import * as styles from './TextColumn.module.css'

import React from 'react'

interface Props {
  children: React.ReactNode
}

const TextColumn: React.FC<Props> = (props) => {
  const { children } = props

  return <div className={styles.container}>{children}</div>
}

export default TextColumn
